export default __webpack_public_path__ + "media/zurb/img/services/process/lift-img-339eda3770bfe904140c496bfb68983f.png";